document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.mobile-menu').forEach((menu) => {
    const container = menu.querySelector('.mobile-menu__panels-container');
    if (!container) return;

    const subPanels = menu.querySelectorAll('.mobile-menu__panel--sub');

    const setActive = (idx) => {
      container.style.transform = `translateX(-${idx * 100}%)`;
      subPanels.forEach((p) => {
        p.classList.toggle('is-active', p.dataset.index === String(idx));
      });
    };

    // Open a sub panel
    menu.querySelectorAll('[data-open-sub]').forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault(); // prevent checkbox toggling from interfering
        const idx = parseInt(el.getAttribute('data-open-sub'), 10);
        if (Number.isFinite(idx)) setActive(idx);
      });
    });

    // Close back to main
    menu.querySelectorAll('[data-close-sub]').forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        container.style.transform = 'translateX(0%)';
        subPanels.forEach((p) => p.classList.remove('is-active'));
      });
    });

    // Escape key closes sub panel
    menu.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        container.style.transform = 'translateX(0%)';
        subPanels.forEach((p) => p.classList.remove('is-active'));
      }
    });
  });
});